import { DropdownItem } from "reactstrap";
import styles from "components/NavMenu/NavMenu.module.css";

interface IProps {
    openMessagesModal: () => void;
}

export default function NavDropdownItem({ openMessagesModal }: IProps) {
    return (
        <DropdownItem onClick={openMessagesModal} className={styles.link}>
            System Status Messages
        </DropdownItem>
    );
}
